const initialState = {
    customer: {
        name: '',
        surname: '',
        email: '',
        address: {
            region: '',
            city: '',
            district: '',
            street: '',
            zip: '',
        },
    },
    loading: false,
    error: null,
};

const customerReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_CUSTOMER_START":
            return {...state, loading: true, error: null};
        case "FETCH_CUSTOMER_SUCCESS":
            return { ...state, customer: action.payload, loading: false };
        case "UPDATE_CUSTOMER":
            return {...state, loading: true, error: null};
        case "UPDATE_CUSTOMER_SUCCESS":
            return { ...state, customer: action.payload, loading: false };
        default:
            return state;
    }
};

export default customerReducer;
